import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import VoxieLogo from './VoxieLogo';
import LanguageSwitcher from './LanguageSwitcher';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  // Determine current language prefix for links
  const getLanguagePrefix = () => {
    const path = location.pathname;
    const segments = path.split('/');
    if (segments.length > 1 && ['es', 'fr', 'pt'].includes(segments[1])) {
      return `/${segments[1]}`;
    }
    return '';
  };
  const langPrefix = getLanguagePrefix();
  return <header className="sticky top-0 z-50 bg-white shadow-sm" data-id="element-57">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-58">
        <div className="flex items-center" data-id="element-59">
          <Link to={langPrefix || '/'} data-id="element-60">
            <div className="flex items-center" data-id="element-61">
              <VoxieLogo className="h-8 w-8 mr-2" data-id="element-62" />
              <span className="text-2xl font-bold text-[#54d4cb]" data-id="element-63">VOXIE</span>
            </div>
          </Link>
        </div>
        <div className="flex items-center" data-id="element-64">
          <div className="hidden md:flex items-center space-x-8 mr-8" data-id="element-65">
            <a href="#how-it-works" className="text-gray-600 hover:text-[#54d4cb] font-medium" data-id="element-66">
              How It Works
            </a>
            <Link to={`${langPrefix}/telecoms`} className="text-gray-600 hover:text-[#54d4cb] font-medium" data-id="element-67">
              Telecoms
            </Link>
            <div className="flex items-center" data-id="element-68">
              <LanguageSwitcher data-id="element-69" />
            </div>
          </div>
          <div className="hidden md:block" data-id="element-70">
            <a href="https://calendly.com/es-lee/intro?referrer=voxiesite" target="_blank" rel="noopener noreferrer" className="bg-[#54d4cb] text-white px-6 py-2 rounded-md font-medium hover:bg-[#43aca5] transition-colors" data-id="element-71">
              Contact Us
            </a>
          </div>
          <div className="md:hidden flex items-center" data-id="element-72">
            <LanguageSwitcher data-id="element-73" />
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-600 hover:text-[#54d4cb] ml-2" data-id="element-74">
              {isMenuOpen ? <XIcon size={24} data-id="element-75" /> : <MenuIcon size={24} data-id="element-76" />}
            </button>
          </div>
        </div>
      </div>
      {isMenuOpen && <div className="md:hidden bg-white px-4 py-2 shadow-md" data-id="element-77">
          <div className="flex flex-col space-y-3 pb-3" data-id="element-78">
            <a href="#how-it-works" className="text-gray-600 hover:text-[#54d4cb] font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-79">
              How It Works
            </a>
            <Link to={`${langPrefix}/telecoms`} className="text-gray-600 hover:text-[#54d4cb] font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-80">
              Telecoms
            </Link>
            <a href="https://calendly.com/es-lee/intro?referrer=voxiesite" target="_blank" rel="noopener noreferrer" className="bg-[#54d4cb] text-white px-6 py-2 rounded-md font-medium hover:bg-[#43aca5] transition-colors" data-id="element-81">
              Contact Us
            </a>
          </div>
        </div>}
    </header>;
};
export default Header;